<!-- BaseTab.vue (admin) -->
<template tag="관리자 탭 컴포넌트">
  <v-tabs v-model="selectedTab" :class="className" :bg-color="bgColor" :color="color">
    <v-tab v-for="tab in tabs" :key="tab.value" :value="tab.value">
      {{ tab.label }}
    </v-tab>
  </v-tabs>
</template>

<script setup lang="ts">
import { defineProps } from "vue";

/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const selectedTab = defineModel<string>();

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
defineProps({
  tabs: { type: Array<{ label: string; value: string }>, default: () => [] },
  bgColor: { type: String, default: "" },
  className: { type: String, default: "" },
  color: { type: String, default: "primary" },
});
</script>
